<template>
  <div class="main">
    <div class="menu-bg-holder">
      <div class="megamenu__main">
        <div class="megamenu__container">
          <div class="megamenu__menus">
            <div
              class="megamenu__submenu"
              v-for="submenu in filteredSubMenu.slice(0, 4)"
              :key="submenu.id"
            >
              <div class="megamenu__submenuHeader">
                <div class="megamenu__Svg">
                  <img
                    :src="
                      submenu.image
                        ? submenu.image
                        : require('../../assets/svg/default.png')
                    "
                  />
                </div>
                <span>
                  {{ submenu.name }}
                </span>

                <div><font-awesome-icon icon="angle-right" /></div>
              </div>
              <div class="megamenu__categoryItems">
                <div
                  class="megamenu__category"
                  v-for="category in submenu.category_info.slice(0, 4)"
                  :key="category.id"
                >
                  <img
                    :src="
                      category.image
                        ? category.image
                        : require('../../assets/cuisines/no_image.jpg')
                    "
                    :alt="category.name"
                  />

                  <span
                    @click="
                      getSubmenu(submenu.id, category.id);
                      $emit('onClose', false);
                    "
                  >
                    {{ category.name }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="megamenu__imageRight"
            v-for="image in menuBanner"
            :key="image.id"
          >
            <div class="megamenu__specialfood">
              <img
                :src="
                  image.img
                    ? image.img
                    : require('../../assets/cuisines/no_image.jpg')
                "
                alt="image"
              />
            </div>
            <button
              @click="
                getRedirectionType(
                  image.redirection_code,
                  image.redirection_type
                );
                $emit('onClose', false);
              "
            >
              Order Now
            </button>
          </div>
        </div>
        <div
          class="megamenu__showMore"
          @click="
            $emit('onClose', false);
            onCategories();
          "
        >
          <span>Expand</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import router from "../../router";
import { LocationId } from "../../services/storage.service";

export default {
  name: "MegaMenu",
  props: ["clicked", "locationId", "menu"],
  data() {
    return {
      menuId: null,
      filteredMenu: null,
      filteredSubMenu: null,
      clicked: null,
      menu: null,
      locationId: this.locationId,
      menuBanner: [],
      error: false,
      loading: true,
      showCategory: null,
    };
  },
  computed: {
    ...mapGetters(["allMenus", "menuIds"]),
  },

  watch: {
    clicked() {
      this.getfilteredMenus();
    },

    allMenus() {},

    // filteredMenu() {
    //   this.getfilteredSubMenus();
    // },
  },

  created() {
    this.getfilteredMenus();
    this.getfilteredSubMenus();
    this.getMenuBanner();
    this.isShowCategory();
  },

  methods: {
    ...mapActions(["getCategoryId"]),

    getId() {
      const _menuId = this.allMenus.map((m) => m.id);
      return (this.menuId = _menuId);
    },

    getfilteredMenus() {
      const _filteredMenu = this.allMenus.filter((i) => i.id === this.clicked);
      this.filteredMenu = _filteredMenu;
    },

    getfilteredSubMenus() {
      const _filteredsubMenu = this.filteredMenu.map((m) => m.submenus);
      this.filteredSubMenu = _filteredsubMenu.flat();
    },

    isShowCategory() {
      const category = this.filteredSubMenu.map((m) => m.category_info.length);
      const showCategory = category.some((bool) => bool >= 4);
      this.showCategory = showCategory;
    },

    getLocationId() {
      return JSON.parse(localStorage.getItem("LOCATION_ID"));
    },

    getMenuBanner() {
      axios
        .post("https://deus.khaanpin.com/appapi/getmenubanner/", {
          loc_id: this.locationId,
          menu_id: this.clicked,
        })
        .then((res) => {
          if (res.data.error) {
            this.error = true;
          } else {
            const filterBanner = res.data.data.filter(
              (banner) => banner.type === "menu"
            );

            this.menuBanner = filterBanner;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onCategories() {
      if (LocationId.getLocationId() == 1) {
        router.push("/ktm/k/" + this.menuIds);
      } else if (LocationId.getLocationId() == 2) {
        router.push("/pkr/k/" + this.menuIds);
      }
    },

    getRedirectionType(redirection_code, redirection_type) {
      if (redirection_type === "search") {
        this.handleSearch(redirection_code);
      } else if (redirection_type === "section") {
        this.getSubmenu(redirection_code);
      }
    },

    // getSubmenu(redirect) {
    //   // alert(redirect.name);
    //   if (LocationId.getLocationId() == 1) {
    //     router.push("/ktm/c/" + this.menu.name || redirect);
    //   } else if (LocationId.getLocationId() == 2) {
    //     router.push("/pkr/c/" + this.menu.name || redirect);
    //   }
    // },

    getSubmenu(subId, catId) {
      // const submenu = this.menu;
      if (LocationId.getLocationId() == 1) {
        // router.push("/ktm/c/" + submenu.name);
        router.push(
          `/ktm/c/${this.menu.name}/${this.menu.id}/${subId}/${catId}`
        );
        // alert(submenu);

        // getCategoryId(submenu);
      } else if (LocationId.getLocationId() == 2) {
        // router.push("/pkr/c/" + submenu.name);
        // router.push(`/pkr/c/${this.menu.name}/${this.menu.id}/${submenu}`);
        router.push(
          `/pkr/c/${this.menu.name}/${this.menu.id}/${subId}/${catId}`
        );
      }
    },

    handleSearch: function (redirect) {
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: redirect },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: redirect },
        });
      }
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,800;1,700&display=swap");

.main {
  position: relative;
}

.menu-bg-holder {
  background-color: #ed2027;
  position: absolute;
  z-index: 999999;
  width: 100%;
}

.megamenu__main {
  background-image: url(../../assets/background/footer.png);
  /* background-color: white; */
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  /* justify-content: space-around; */
  /* position: absolute; */
  /* color: #ffffff; */
  /* border :2px solid black; */
  position: relative;
  box-shadow: 0 1px 3px #0000001f, 0 1px 2px #0000003d;
  width: 100%;
  opacity: 1;
  z-index: 999999;
  transition: all 0.8s ease;
  min-height: 400px;
  font-family: "Open Sans", sans-serif;
}
.megamenu__container {
  display: flex;
  flex-direction: row;
}

.megamenu__submenuHeader {
  display: flex;
  align-items: center;
  /* border: 1px solid black; */
}

.megamenu__submenuHeader > span {
  padding: 0 12px 0 5px;
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  letter-spacing: 0.5px;
  color: white;
}

.megamenu__submenu {
  /* border: 1px solid red; */
  width: 100%;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.megamenu__menus {
  flex: 9;
  /* border-right: 1px solid rgb(202, 195, 195); */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  padding: 1.5rem;
  color: #ed2027;
  /* font-weight: bolder; */
  font-size: 18px;
  font-family: "Open Sans", sans-serif;

  /* border: 1px solid black; */
  /* margin: 1rem 0; */
}

.megamenu__Svg > img {
  height: 30px;
  /* width: 20px; */
  width: 30px;
  object-fit: cover;
  /* color: red; */
  /* color: white !important; */
  fill: white !important;
  /* background-color: white; */
  border-radius: 8px;
}

.megamenu__categoryItems {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: flex-start;
  /* border: 1px solid yellow; */
  margin: 0.8rem 0 1rem 0;
}

.megamenu__category {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  /* border : 1px solid red; */

  cursor: pointer;
}
.megamenu__category:hover {
  /* text-decoration: underline; */
  /* transition: 0.8s ease-in all; */
  color: red;
}

.megamenu__showMore {
  font-size: 16px;
  cursor: pointer;
  /* font-weight: bolder; */
  color: white;
  position: absolute;
  bottom: 0.5%;

  /* border: 1px solid black; */
  /* margin-top: -10px; */
  width: 100%;
  font-family: "Open Sans", sans-serif;

  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
}

.megamenu__showMore:hover {
  /* color: #222222; */

  transition: 0.3s ease all;
  text-decoration: underline;
}
.megamenu__category > img {
  height: 48px;
  width: 48px;
  border-radius: 12px;
  margin-right: 25px;
  object-fit: cover;
  /* border: 1px solid black; */
  background-color: white;
}

.megamenu__category > span {
  font-size: 16px;
  /* border: 1px solid black; */
  text-transform: initial;
  font-weight: 500;
  color: white;
  /* color: black; */
}

.megamenu__category > span:hover {
  color: #c9c9c9;
}

.megamenu__imageRight {
  flex: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #cccccc;
  margin: 1rem 0;
}

.menubanner__loading {
  color: #ed2027;
}

.megamenu__specialfood {
  /* border-left: 1px solid grey; */
  border-radius: 15px;
}

.megamenu__specialfood > img {
  height: 350px;
  width: 300px;
  object-fit: cover;
  border-radius: 12px;
  cursor: pointer;
}

.megamenu__imageRight > button {
  border: 1px solid #ed2027;

  font-family: "Open Sans", sans-serif;

  font-weight: bolder;
  padding: 10px 18px;
  margin-top: 18px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #ffffff;
  background: #ed2027;
}

.megamenu__imageRight > button:hover {
  color: #ffffff;
  background: red;
  /* font-size: 15px; */
  transition: 0.8s ease all;
}
</style>
